import { Button } from "@jugl-web/ui-components";
import { FC } from "react";

export interface ChatMessagesLoadErrorProps {
  onRetry?: () => void;
}

/**
 * Inline error banner shown inside the message list when loading the conversation history fails.
 */
export const ChatMessagesLoadError: FC<ChatMessagesLoadErrorProps> = ({
  onRetry,
}) => (
  <div className="mb-4 rounded-lg border border-solid border-red-200 bg-red-50 p-4">
    <div className="flex items-center justify-between">
      <div className="flex-1">
        <p className="font-secondary m-0 text-sm font-medium text-red-800">
          Failed to load messages
        </p>
        <p className="font-secondary m-0 mt-1 text-xs text-red-600">
          An error occurred while loading messages.
        </p>
      </div>
      {onRetry && (
        <Button onClick={onRetry} size="small" color="tertiary">
          Retry
        </Button>
      )}
    </div>
  </div>
);
